import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants';

const formatDate = (date) => {
  if (date) {
    return moment(date).format(DATE_TIME_FORMAT);
  } else {
    return 'No Date';
  }
};

const PurchaseList = ({ purchases, actionComponent }) => (
  <div>
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Purchase Type</th>
          <th>Purchase Date</th>
          <th>Payment Date</th>
          <th>Total</th>
          <th>Status</th>
          <th>Card Charged</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {purchases.length > 0 &&
          purchases.map((purchase) => (
            <tr key={purchase.id}>
              <td>{purchase.id}</td>
              <td>{purchase.purchase_type}</td>
              <td>{formatDate(purchase.purchase_date)}</td>
              <td>{formatDate(purchase.payment_date)}</td>
              <td>${purchase.cost.total}</td>
              <td className="text-uppercase">{purchase.status}</td>
              <td>{purchase.charge_card}</td>
              <td>
                {actionComponent ? (
                  actionComponent(purchase)
                ) : (
                  <Link to={`/purchases/${purchase.id}/view`}>View</Link>
                )}
              </td>
            </tr>
          ))}
        {purchases.length === 0 ? (
          <tr>
            <td colSpan="6">No purchases yet</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  </div>
);

export default PurchaseList;
